import { render } from "./GerenciamentoTransportadoras.vue?vue&type=template&id=6ddd91d9"
import script from "./GerenciamentoTransportadoras.vue?vue&type=script&lang=js"
export * from "./GerenciamentoTransportadoras.vue?vue&type=script&lang=js"

import "./GerenciamentoTransportadoras.vue?vue&type=style&index=0&id=6ddd91d9&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__